<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
             <v-card class='mb-2'>
                  <v-card-title class="ml-4">
                    <v-flex xs10 justify-center align-center class='text-xs-center'> 
                      <h1>{{programaData.name}}</h1>
                    </v-flex>
                    <v-flex xs2 v-if="editing">
                      <v-icon
                        size="25"
                        @click="dialog = true"
                        style="float: right" 
                      >
                        delete
                      </v-icon>                      
                    </v-flex>
                    <v-flex xs12 md9 justify-start>
                      <profile-text title="Nome : " v-model='programaData.name'
                        :editing='editing'></profile-text>
                      <profile-text title="Descrição : " v-model='programaData.description'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                        <div style="height: 1rem"></div>
                      <p v-if="!editing">
                        <strong style="font-size: 1.2rem">Unidades: </strong>
                      <!-- <a href="#" 
                        > -->
                      <!-- @click.prevent="goToUnidade(un.slug)"> -->
                          <v-chip label
                          v-for="un 
                          in selectUnidade"
                          :key='un.name'
                          desable 
                          color='amber'
                          outline>
                              {{un.name}}
                          </v-chip>
                      <!-- </a> -->
                      </p>
                      <p v-if="!editing">
                        <strong style="font-size: 1.2rem">Ano: </strong>
                      <!-- <a href="#" 
                        > -->
                      <!-- @click.prevent="goToUnidade(un.slug)"> -->
                          <v-chip label
                          v-for="un 
                          in programaData.ano"
                          :key='un.name'
                          desable 
                          color='primary'
                          outline>
                              {{un}}
                          </v-chip>
                      <!-- </a> -->
                      </p>
                      <v-autocomplete
                        v-if="editing"
                        label="Ano(s)"
                        :items="ano"
                        item-text="name"
                        item-value="slug"
                        v-model="programaData.ano"
                        max-height="400"
                        multiple
                        hint="Escolha o(s) programa(s)"
                        persistent-hint
                        ></v-autocomplete>
                    </v-flex>  
                      
                  </v-card-title>
                   <v-btn
                      v-if="this.$store.state.selectedRole.name === 'Admin' || permissao"
                      absolute
                      dark
                      fab
                      bottom
                      right
                      color="blue"
                      @click="pressFloatingButton()"
                      >
                      <v-icon v-if='!editing'>mode_edit</v-icon>
                      <v-icon v-else>done</v-icon>
                    </v-btn>
              </v-card>
          </v-flex>
          <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline">Deseja deletar?</v-card-title>
              <v-card-text>Gostaria excluir esse programa ?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat @click.native="dialog = false">Cancelar</v-btn>
                <v-btn color="green darken-1" flat @click.native="excluir()">Deletar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-layout>
</template>

<script>

import api from '@/api'
import ProfileText from '@/components/reusable/ProfileText.vue'
export default {
  components: {
    ProfileText
  },
  data () {
    return {
      programaData: {
        name: '',
        unidade: [],
        description: '',
        slug: ''

      },
      currentTab: 'Sobre',
      showImageUpload: false,
      imageChangeModal: false,
      editing: false,
      dialog: false,
      avaliando: false,
      evid_avaliada: {},
      dialog_criterios: false,
      tempData: {},
      options: {},
      ano: [],
      evidencias: {},
      selectUnidade: [],
      criterios: {},
      page: 1
    }
  },
  mounted () {
    var projectid = this.$route.params.slug
    api.request('GET', 'programas/' + projectid + '/').then(response => {
      this.programaData = response.data
      console.log(this.programaData)
    })
    api.request('GET', 'unidade/').then(resp => {
      this.unidades = resp.data
      this.filtroUnidade(resp.data)
    })
    api.request('GET', 'ano/').then(resp => {
      resp.data.sort((a, b) => (a.order_number > b.order_number) ? 1 : ((b.order_number > a.order_number) ? -1 : 0))
      this.ano = resp.data
    })
  },
  watch: {
  },
  computed: {
    permissao () {
      return this.$store.state.user.is_superuser
    }
  },
  methods: {
    goToUnidade (unidade) {
      this.$router.push('/unidade/' + unidade)
    },
    filtroUnidade (unidade) {
      this.selectUnidade = unidade.filter(value => {
        return (value.programa.some(el => el === this.programaData.slug))
      })
    },
    // getUserImage (username) {
    //   var userarray = this.programaData.integrantes.filter(value => {
    //     return value.username === username
    //   })
    //   if (userarray[0]) {
    //     return userarray[0].profilePic
    //   } else {
    //     return ''
    //   }
    // },
    getUser (username) {
      var userarray = this.programaData.integrantes.filter(value => {
        return value.username === username
      })
      return userarray[0]
    },
    pressFloatingButton () {
      if (this.editing) {
        this.performSave()
      } else {
        this.editing = !this.editing
      }
    },
    excluir () {
      api.request('DELETE', 'programas/' + this.$route.params.slug + '/').then(resp => {
        this.$router.push('/programas')
      })
    },
    performSave () {
      var slugid = this.$route.params.slug
      let self = this
      api
        .request('PATCH', 'programas/' + slugid + '/', {
          'description': self.programaData.description,
          'name': self.programaData.name, // vai editar nome?,
          'ano': self.programaData.ano
        })
        .then(function (response) {
          console.log(response)
        })
      self.editing = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Programa/Detail.vue